<!-- @format -->

<mat-toolbar style="display: flex">
  <fa-icon icon="tags" class="headerIcon"></fa-icon>
  <span>{{ _common.space_categories }}</span>

  <div class="flex-auto"></div>
</mat-toolbar>
<div class="ctlSearchBar">
  <div class="searchField">
    <fa-icon matPrefix icon="search" class="searchIcon"></fa-icon>
    <input
      matInput
      (keyup)="applyFilter($any($event.target).value)"
      placeholder="{{ _common.search }}"
      #_search
    />
    <fa-icon
      icon="times"
      matSuffix
      (click)="clearFilter(_search)"
      class="clearSearch"
    ></fa-icon>
  </div>

  <div class="app-filter-bar">
    <div>
      <fa-icon icon="sliders-h"></fa-icon>
    </div>
    <div class="content">
      <app-filter-date-range-button
        [dateRange]="dateRange"
        (update)="refresh()"
      ></app-filter-date-range-button>
      <!-- <app-filter-object #_member [filter]="memberFilter" (change)="refresh()" (select)="selectMember($event)">
        Member
      </app-filter-object> -->
    </div>
    <!-- <div (click)="filterObject.openFilter()" class="openFilter">
      <fa-icon icon="ellipsis-h"></fa-icon>
    </div> -->
  </div>
  <div class="app-btn btn-icon" (click)="refresh()">
    <fa-icon icon="sync"></fa-icon>
  </div>

  <span class="spacer"></span>
  <!-- Hide for Now <span>
    <button class="app-btn btn-text" (click)="exportList()">
      <fa-icon icon="download"></fa-icon>
      {{_common.export}}
    </button>
  </span> -->
</div>

<app-scroll-container
  [more]="hasMore()"
  (scrolled)="handleScroll($event)"
  class="max-scroll card-shadow"
  #scroll
>
  <table
    mat-table
    [dataSource]="objects"
    class="app-table scroll"
    matSort
    (matSortChange)="sortData($event)"
  >
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox
          (change)="$event ? masterToggle() : null"
          [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()"
        >
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row" class="datatable-select">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)"
        >
        </mat-checkbox>
      </td>
    </ng-container>
    <ng-container matColumnDef="member">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="member.name">
        {{ _common.name }} ({{ rowCount }})
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.member?.name }}
        <div class="text-xs text-gray-400">{{ element.member?.userId }}</div>
      </td>
    </ng-container>
    <ng-container matColumnDef="memberType">
      <th mat-header-cell *matHeaderCellDef>
        {{ _common.user_type }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.member?.memberType?.name }}
      </td>
    </ng-container>
    <ng-container matColumnDef="admin">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <fa-icon icon="desktop" *ngIf="element.admin"></fa-icon>
      </td>
    </ng-container>
    <ng-container matColumnDef="time">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="time">
        {{ _common.thinkdesks.time }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{ formatTime(element.time) }}
      </td>
    </ng-container>
    <ng-container matColumnDef="controls" stickyEnd>
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element" class="floating-buttons">
        <button class="app-btn btn-text" (click)="selectObject(element)">
          <fa-icon icon="pen"></fa-icon>
          {{ _common.edit }}
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      class="datatable-row"
    ></tr>
  </table>
</app-scroll-container>

<div
  *ngIf="filterObject.showFilter"
  class="ctlFilter listFilter"
  (clickOutsidePopup)="filterObject.closeFilter()"
>
  <div class="header">
    <div class="title">
      <fa-icon icon="sliders-h" style="margin-right: 5px"></fa-icon>
      {{ _common.filters }}
    </div>
    <div class="spacer"></div>
    <div
      (click)="filterObject.closeFilter()"
      style="font-size: 1.5em; cursor: pointer"
    >
      <fa-icon icon="times"></fa-icon>
    </div>
  </div>
  <div class="body"></div>
  <div class="buttons">
    <div (click)="filterObject.clear(); refresh()" class="clear_button">
      {{ _common.ClearAll }}
    </div>
  </div>
</div>
